export enum LinkEnum {
  LinkedInProfile = "https://www.linkedin.com/in/mkwarman",
  GitHubProfile = "https://www.github.com/mkwarman",
}

export const MONTHS_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];